import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../service/modules/modules.component';
import { ServerService } from '../../service/server/server.service';
import { MessageService } from '../../service/message/message.service';
import { InsertComponent } from '../../service/insert/insert.component';

@Component({
  selector: 'app-wharehouse-order-costs-detaile',
  templateUrl: './wharehouse-order-costs-detaile.component.html',
  styleUrls: ['./wharehouse-order-costs-detaile.component.scss']
})
export class WharehouseOrderCostsDetaileComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public type_task!: number;
  public loading: boolean = false;
  public subscription: Subscription | any;
  public form1_group: FormGroup | any;
  public server!: any;
  public user_id!: number;
  public id!: number;
  public reception_id!: number;
  public creator!: number;
  public result!: any;
  public readonly!: boolean;
  constructor(
    public serverService: ServerService,
    public router: Router,
    public messageService: MessageService,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<WharehouseOrderCostsDetaileComponent>) {
    this.server = this.serverService.get_server();
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.reception_id = dialog_data.reception_id;
      this.creator = dialog_data.creator;
      this.readonly = dialog_data.readonly;
      this.create_form1();
      this.id = dialog_data.id;
      if (this.type_task == 1) {
      }
      if (this.type_task == 2) {
        this.get_data();
      }
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }
  create_form1() {
    this.form1_group = new FormGroup({
      'costs_title': new FormControl(null),
      'costs': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'cost': new FormControl(null, [Validators.pattern('[0-9]{1,}')])
    });
  }
  get_data() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 7159,
      'id': this.id,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'costs_title': res['result'][0].orders_costs_title,
            'costs': res['result'][0].orders_costs_id,
            'cost': res['result'][0].wharehouse_order_cost,
          }
          )
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  check_reception_for_material() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 7143,
      'id': this.reception_id,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          if (this.type_task == 1) {
            this.insert();
          } else {
            this.update();
          }
        }//end if
        else {
          var pe_message = "این پذیرش قبلا حذف شده است";
          this.message(true, this.messageService.message(pe_message), 1, this.messageService.close());
        }
      }
    )
  }
  insert() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 7157,
      'creator': this.creator,
      "user_id": this.user_id,
      'costs': this.form1_group.value.costs,
      'cost': this.form1_group.value.cost,
      'reception_id': this.reception_id,
      'id': this.id,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.result = res['result'][0];
          this.matDialogRef.close(this.result);
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }
  update() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 7158,
      'creator': this.creator,
      "user_id": this.user_id,
      'costs': this.form1_group.value.costs,
      'cost': this.form1_group.value.cost,
      'reception_id': this.reception_id,
      'id': this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.result = res['result'][0];
          this.matDialogRef.close(this.result);
          //this.serverService.send_payments(1);
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }//end update
  load_services(id: number) {
    if (this.readonly == true) {
      return false;
    }
    var code_id!: number;
    if (id == 281) {
      code_id = 7134;
    }
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: {
        id: id, creator: this.creator, code_id: code_id
      }
    })
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (id == 281) {
            this.form1_group.patchValue({
              'costs': res.id,
              'costs_title': res.title
            });
          }
        }
      }
    )
  }
  reset_input(id: number): any {
    if (this.readonly == true) {
      return false;
    }
    if (id == 281) {
      this.form1_group.patchValue({
        'costs': null,
        'costs_title': null
      })
    }
  }
  close() {
    this.matDialogRef.close();
  }
  add_cost() {
    const dialogRef = this.dialog.open(InsertComponent, {
      width: '22rem',
      height: 'auto',
      data: { creator: this.creator, service: 'costs' }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.form1_group.patchValue({
            'costs': res.orders_costs_id,
            'costs_title': res.orders_costs_title,
          });
        }
      }
    )
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}